export interface FeatureConfig {
    requiresPaid: boolean;
    showInMenu: boolean;
    routePath?: string;
    redirectTo?: string;
}

export interface FeatureAccess {
    [key: string]: FeatureConfig;
}

export const FEATURE_ACCESS: FeatureAccess = {
    'ai-jobs': {
        requiresPaid: true,
        showInMenu: true,
        routePath: '/ai-jobs',
        redirectTo: '/unlock-silverplus'
    },
    'cv-generator': {
        requiresPaid: true,
        showInMenu: true,
        routePath: '/cv-generator',
        redirectTo: '/unlock-silverplus'
    },
    'cover-letter-generator': {
        requiresPaid: true,
        showInMenu: true,
        routePath: '/cover-letter-generator',
        redirectTo: '/unlock-silverplus'
    },
    'interview-prep': {
        requiresPaid: true,
        showInMenu: true,
        routePath: '/interview-prep',
        redirectTo: '/unlock-silverplus'
    },
    'job-coach': {
        requiresPaid: true,
        showInMenu: true,
        routePath: '/job-coach',
        redirectTo: '/unlock-silverplus'
    },
    'rentensteuerberater': {
        requiresPaid: true,
        showInMenu: true,
        routePath: '/rentensteuerberater',
        redirectTo: '/unlock-silverplus'
    },
    'online-courses': {
        requiresPaid: true,
        showInMenu: true,
        routePath: '/online-courses',
        redirectTo: '/unlock-silverplus'
    },
    'subscription-management': {
        requiresPaid: false,
        showInMenu: true,
        routePath: '/account',
        redirectTo: '/unlock-silverplus'
    }
};

export const PREMIUM_FEATURES = Object.keys(FEATURE_ACCESS).filter(
    feature => FEATURE_ACCESS[feature].requiresPaid
);

// Utility function to check if a user can access a feature
export const canAccessFeature = (feature: string, userPlanType?: string): boolean => {
    const featureConfig = FEATURE_ACCESS[feature];
    if (!featureConfig) {
        // If feature is not in config, allow access (free features)
        return true;
    }

    if (!featureConfig.requiresPaid) {
        return true;
    }

    // Check if user has paid plan
    return userPlanType === 'paid';
};

// Utility function to check if a feature should be shown in menu
export const shouldShowInMenu = (feature: string, userPlanType?: string): boolean => {
    const featureConfig = FEATURE_ACCESS[feature];
    if (!featureConfig) {
        return true; // Show free features by default
    }

    // If feature doesn't belong in menu, don't show
    if (!featureConfig.showInMenu) {
        return false;
    }

    // If feature requires paid access and user is not paid, don't show
    if (featureConfig.requiresPaid && userPlanType !== 'paid') {
        return false;
    }

    return true;
};

export default FEATURE_ACCESS;
